import { useId } from 'react';

/** Protected links (spec §9.3): a tiled diagonal watermark over the canvas, under the UI, never hit-tested. */
export function Watermark({ text }: { text: string }) {
  const pattern = `wm-${useId().replace(/:/g, '')}`;
  return (
    <svg data-testid="watermark" aria-hidden="true" className="absolute inset-0 z-10 h-full w-full" style={{ pointerEvents: 'none' }}>
      <defs>
        <pattern id={pattern} width="360" height="220" patternUnits="userSpaceOnUse" patternTransform="rotate(-24)">
          <text x="180" y="110" textAnchor="middle" fill="rgba(128,128,128,0.22)" fontFamily="sans-serif" fontSize="18">
            {text}
          </text>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${pattern})`} />
    </svg>
  );
}
